// get_product_launchers
export const GET_PRODUCT_LAUNCHERS = 'get_product_launchers';
export const GET_PRODUCT_LAUNCHERS_SUCCESSFUL =
  'get_product_launchers_successfull';
export const GET_PRODUCT_LAUNCHERS_FAILED = 'get_product_launchers_failed';

// create_product_launcher
export const CREATE_PRODUCT_LAUNCHER = 'create_product_launcher';
export const CREATE_PRODUCT_LAUNCHER_SUCCESSFUL =
  'create_product_launcher_successfull';
export const CREATE_PRODUCT_LAUNCHER_FAILED = 'create_product_launcher_failed';

// update_product_launcher
export const UPDATE_PRODUCT_LAUNCHER = 'update_product_launcher';
export const UPDATE_PRODUCT_LAUNCHER_SUCCESSFUL =
  'update_product_launcher_successfull';
export const UPDATE_PRODUCT_LAUNCHER_FAILED = 'update_product_launcher_failed';

// delete_product_launcher
export const DELETE_PRODUCT_LAUNCHER = 'delete_product_launcher';
export const DELETE_PRODUCT_LAUNCHER_SUCCESSFUL =
  'delete_product_launcher_successfull';
export const DELETE_PRODUCT_LAUNCHER_FAILED = 'delete_product_launcher_failed';

// -----------------------------
// submit_product_basic
export const SUBMIT_PRODUCT_BASIC = 'submit_product_basic';
export const SUBMIT_PRODUCT_BASIC_SUCCESSFUL =
  'submit_product_basic_successfull';
export const SUBMIT_PRODUCT_BASIC_FAILED = 'submit_product_basic_failed';

// get_product_subcategory_by_category
export const GET_PRODUCT_SUBCATEGORY_BY_CATEGORY =
  'get_product_subcategory_by_category';
export const GET_PRODUCT_SUBCATEGORY_BY_CATEGORY_SUCCESSFUL =
  'get_product_subcategory_by_category_successfull';
export const GET_PRODUCT_SUBCATEGORY_BY_CATEGORY_FAILED =
  'get_product_subcategory_by_category_failed';

// GET_PRODUCT_CATEGORY_FAQ
export const GET_PRODUCT_CATEGORY_FAQ = 'GET_PRODUCT_CATEGORY_FAQ';
export const GET_PRODUCT_CATEGORY_FAQ_SUCCESSFUL =
  'GET_PRODUCT_CATEGORY_FAQ_successfull';
export const GET_PRODUCT_CATEGORY_FAQ_FAILED =
  'GET_PRODUCT_CATEGORY_FAQ_FAILED';

// submit_product_assessments
export const SUBMIT_PRODUCT_ASSESSMENTS = 'submit_product_assessments';
export const SUBMIT_PRODUCT_ASSESSMENTS_SUCCESSFUL =
  'submit_product_assessments_successfull';
export const SUBMIT_PRODUCT_ASSESSMENTS_FAILED =
  'submit_product_assessments_failed';

// get_product_members
export const GET_PRODUCT_MEMBERS = 'get_product_members';
export const GET_PRODUCT_MEMBERS_SUCCESSFUL = 'get_product_members_successfull';
export const GET_PRODUCT_MEMBERS_FAILED = 'get_product_members_failed';

// add_product_member
export const ADD_PRODUCT_MEMBER = 'add_product_member';
export const ADD_PRODUCT_MEMBER_SUCCESSFUL = 'add_product_member_successfull';
export const ADD_PRODUCT_MEMBER_FAILED = 'add_product_member_failed';

// get_product
export const GET_PRODUCT = 'get_product';
export const GET_PRODUCT_SUCCESSFUL = 'get_product_successfull';
export const GET_PRODUCT_FAILED = 'get_product_failed';

// get_workspaces
export const GET_WORKSPACES = 'get_workspaces';
export const GET_WORKSPACES_SUCCESSFUL = 'get_workspaces_successfull';
export const GET_WORKSPACES_FAILED = 'get_workspaces_failed';

// add_project_workspace
export const ADD_PROJECT_WORKSPACE = 'add_project_workspace';
export const ADD_PROJECT_WORKSPACE_SUCCESSFUL =
  'add_project_workspace_successfull';
export const ADD_PROJECT_WORKSPACE_FAILED = 'add_project_workspace_failed';

// add_workspace_member
export const ADD_WORKSPACE_MEMBER = 'add_workspace_member';
export const ADD_WORKSPACE_MEMBER_SUCCESSFUL =
  'add_workspace_member_successfull';
export const ADD_WORKSPACE_MEMBER_FAILED = 'add_workspace_member_failed';

// get_workspace
export const GET_WORKSPACE = 'get_workspace';
export const GET_WORKSPACE_SUCCESSFUL = 'get_workspace_successfull';
export const GET_WORKSPACE_FAILED = 'get_workspace_failed';

// remove_product_member
export const REMOVE_PRODUCT_MEMBER = 'remove_product_member';
export const REMOVE_PRODUCT_MEMBER_SUCCESSFUL =
  'remove_product_member_successfull';
export const REMOVE_PRODUCT_MEMBER_FAILED = 'remove_product_member_failed';

// get_project_workspaces
export const GET_PROJECT_WORKSPACES = 'get_project_workspaces';
export const GET_PROJECT_WORKSPACES_SUCCESSFUL =
  'get_project_workspaces_successfull';
export const GET_PROJECT_WORKSPACES_FAILED = 'get_project_workspaces_failed';

// get_workspace_recommended_experts
export const GET_WORKSPACE_RECOMMENDED_EXPERTS =
  'get_workspace_recommended_experts';
export const GET_WORKSPACE_RECOMMENDED_EXPERTS_SUCCESSFUL =
  'get_workspace_recommended_experts_successfull';
export const GET_WORKSPACE_RECOMMENDED_EXPERTS_FAILED =
  'get_workspace_recommended_experts_failed';

// invite_workspace_experts
export const INVITE_WORKSPACE_EXPERTS = 'invite_workspace_experts';
export const INVITE_WORKSPACE_EXPERTS_SUCCESSFUL =
  'invite_workspace_experts_successfull';
export const INVITE_WORKSPACE_EXPERTS_FAILED =
  'invite_workspace_experts_failed';
